import type { AchievementDefinition } from "./types";
import { normalAchievementDefinitions } from "./normalAchievementDefinitions";
import { secretAchievementDefinitions } from "./secretAchievementDefinitions";

export {
  GLOBAL_HOV_GAIN_UPGRADE_MILESTONE_ACHIEVEMENT_LEVEL,
  GLOBAL_HOV_GAIN_UPGRADE_TENTH_MILESTONE_ACHIEVEMENT_LEVEL,
  CHEAP_FOURTH_HOV_GAIN_UNLOCK_COST_THRESHOLD,
  ONE_COST_BATCH_UPGRADE_HOV_GAIN_LEVEL,
  ONE_COST_BATCH_UPGRADE_TRIGGER_COST_THRESHOLD,
  H9G_UPGRADE_MILESTONE_ACHIEVEMENT_LEVEL,
  HOV_GAIN_FAMILY_UPGRADE_PURCHASE_THRESHOLD,
  HOV_GAIN_FAMILY_UPGRADE_MARATHON_PURCHASE_THRESHOLD,
  MASS_HOV_GAIN_FAMILY_UPGRADE_PURCHASE_THRESHOLD,
  AMPLIFIER_UPGRADE_PURCHASE_THRESHOLD,
  MUSIC_POINTER_ASSIGNED_MP_THRESHOLD,
  MOVIE_POINTER_ASSIGNED_MP_THRESHOLD,
  MASCHINEN_POINTER_ASSIGNED_MP_THRESHOLD,
  TIM_HOV_ACTIVATION_UNLOCK_HOV_REFINED_FROM_TIM_THRESHOLD,
  TIME_HAS_COME_TOTAL_TIM_SPENT_THRESHOLD,
  BURN_THE_CORE_TOTAL_HOV_CORE_SPENT_THRESHOLD,
  VIGINTILLION_HOV_THRESHOLD,
  GOOGLE_HOV_THRESHOLD,
  FAST_OUTSIDE_HOV_MAX_DURATION_MS,
  QUICK_OUTSIDE_HOV_MAX_DURATION_MS,
  SWIFT_OUTSIDE_HOV_MAX_DURATION_MS,
  TENTH_OUTSIDE_HOV_COUNT_THRESHOLD,
  BILLION_HOV_THRESHOLD,
  POP_GRID_INCREASE_TARGET_SECONDS,
  BOMB_GRID_INCREASE_TARGET_SECONDS,
  NHOV_KNOWS_NHOV_HG_EFFECTS_TO_HNG_THRESHOLD,
  NOT_FULLY_FREE_HG_COST_DIVISOR_THRESHOLD,
  MASSIVE_MERGE_HOV_MHOV_MULTIPLIER_THRESHOLD,
  RANK_GAP_H9G_TO_H1G_RATIO_THRESHOLD,
  HOV_1_GAIN_TRIES_TOO_LOG10_THRESHOLD,
  HOV_1_GAIN_GETS_SERIOUS_LOG10_THRESHOLD,
  EXPLORATION_BIOME_LEVEL_ACHIEVEMENT_THRESHOLD,
} from "./normalAchievementDefinitions";
export {
  HEAVY_POINTER_HOLD_SECONDS,
  OBSERVER_TARGET_SECONDS,
  HOV_CELL_RAPID_CLICK_TARGET,
  HOV_O_LABEL_HOVER_SECONDS,
  X_PATTERN_HOLD_SECONDS,
  H_PATTERN_HOLD_SECONDS,
} from "./secretAchievementDefinitions";

export const achievementDefinitions: readonly AchievementDefinition[] = [
  ...normalAchievementDefinitions,
  ...secretAchievementDefinitions,
];
